import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import { Cookies } from 'react-cookie';
import axios from 'axios';

const initialState = {
    data: [],
    total: 0,
    pages: 0,
    current: 0,
    user: null,
    error: null,
    loading: false,
}

export const AdminUserReq = createAsyncThunk('AdminUserReq', async ({ role, page }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/users/${role}/list?page=${page}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminUserSearch = createAsyncThunk('AdminUserSearch', async ({ role, page, text, country }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/users/${role}/list?page=${page}&text=${text}&country=${country}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminSingleUserReq = createAsyncThunk('AdminSingleUserReq', async ({ id, role }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/user/profile/${id}/${role}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    // dispatch(toastSuccess(res?.data?.message))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminUserUpdate = createAsyncThunk('AdminUserUpdate', async ({ id, role, data }, { rejectWithValue, dispatch }) => {
    try {
        const cookies = new Cookies()
        const response = await axios.put(`${BASEURL}/admin/user/update/${id}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${cookies.get('auth')}`,
                }
            }).then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(AdminSingleUserReq({ id, role: role }))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const deleteUserReq = createAsyncThunk('deleteUserReq', async ({ id, role, page }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/delete/user/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(AdminUserReq({ role: role, page: page ? page : 1 }))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const verifyUserVechileDoc = createAsyncThunk('verifyUserVechileDoc', async ({ user, status, role, vechile, reason }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/driver/vechile/verify/${user}`, { status: status, vechile: vechile, reason: reason },
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(AdminSingleUserReq({ id: user, role: role }))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const verifyUserReq = createAsyncThunk('verifyUserReq', async ({ id, role, data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/user/verifiy/${id}/${role}`, data, { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(AdminSingleUserReq({ id: id, role: role }))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminUserActiveDeactiveReq = createAsyncThunk('AdminUserActiveDeactiveReq', async ({ id, role, status }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/user/active/deactive/${id}/${role}`, { status },
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const UsersSlice = createSlice({
    name: 'usersSlice',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(AdminUserReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.data = []
            state.current = 0
            return state
        })
        builder.addCase(AdminUserReq.fulfilled, (state, action) => {
            state.loading = false
            state.total = action.payload.data.total
            state.pages = action.payload.data.pages
            state.current = action.payload.data.current
            state.data = action.payload.data?.users
            return state
        })
        builder.addCase(AdminUserReq.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.data = []
            state.current = 0
            state.error = 'Error occured'
        })
        builder.addCase(AdminUserSearch.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.data = []
            state.current = 0
            return state
        })
        builder.addCase(AdminUserSearch.fulfilled, (state, action) => {
            state.loading = false
            state.total = action.payload?.data?.total
            state.pages = action.payload?.data?.pages
            state.current = action.payload?.data?.current
            state.data = action.payload.data?.users
            return state
        })
        builder.addCase(AdminUserSearch.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.data = []
            state.current = 0
            state.error = 'Error occured'
        })
        builder.addCase(AdminSingleUserReq.pending, (state, action) => {
            state.loading = true
            state.user = null
            return state
        })
        builder.addCase(AdminSingleUserReq.fulfilled, (state, action) => {
            state.loading = false
            state.user = action.payload.data
            return state
        })
        builder.addCase(AdminSingleUserReq.rejected, (state, action) => {
            state.loading = false
            state.user = null
            state.error = 'Error occured'
        })
        builder.addCase(AdminUserActiveDeactiveReq.pending, (state, action) => {
            state.user = null
            state.loading = true
            return state
        })
        builder.addCase(AdminUserActiveDeactiveReq.fulfilled, (state, action) => {
            console.log(action.payload.data)
            state.user = action.payload.data
            state.loading = false
            return state
        })
        builder.addCase(AdminUserActiveDeactiveReq.rejected, (state, action) => {
            state.user = null
            state.loading = true
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default UsersSlice.reducer